// Function loadGridContainerBlock loads the GridContainerBlock class by dynamically importing the js on demand if needed

export function loadGridContainerBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-grid-container-block-chunk" */ '../widgets/gridContainerBlock').then(wg => {

		const { GridContainerBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="GridContainerBlock"]');

		if(!$wg) {
			// console.info('GridContainerBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="GridContainerBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new GridContainerBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new GridContainerBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the GridContainerBlock widget');

}
